export class ReleaseOfUnwantedCnaeModel {
  id: number = 0;
  institution: string = '';
  serviceContract: number = 0;
  cnpj: string = '';
  cnae: number = 0;
  clientName: string = '';
  initialDate: string | Date | null = null;
  finalDate: string | Date | null = null;
  isEnabled: boolean = false;
}

export class ReleaseOfUnwantedCnaeCreateModel {
  institution: string = '';
  serviceContract: number = 0;
  cnpj: string = '';
  cnae: number = 0;
  clientName: string = '';
  initialDate: string | Date | null = null;
  finalDate: string | Date | null = null;
}

export class ReleaseOfUnwantedCnaeUpdateModel {
  id: number = 0;
  cnpj: string = '';
  cnae: number = 0;
  clientName: string = '';
  initialDate: string | Date | null = null;
  finalDate: string | Date | null = null;
}

export class ReleaseOfUnwantedCnaeAuditModel {
  cnpj: string = '';
  cnae: number = 0;
  clientName: string = '';
  initialDate: string | Date | null = null;
  finalDate: string | Date | null = null;
  documentUser: string = '';
  nameUser: string = '';
  action: string = '';
  actionDateTime: string | Date | null = null;
}

export class ReleaseOfUnwantedCnaeUpdateStatusModel {
  id: number = 0;
  isEnabled: boolean = false;
}

export class SearchReleaseOfUnwantedCnaeModel {
  size: string = '';
  pageNumber: string = '';
  institution: string = '';
  serviceContract: number = 0;
}
